"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.makeRuleProductFactory = makeRuleProductFactory;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _lowerCase2 = _interopRequireDefault(require("lodash/lowerCase"));
function makeRuleProductFactory(convertAndFormat) {
  if (convertAndFormat === void 0) {
    convertAndFormat = function convertAndFormat(x) {
      return x;
    };
  }
  return function ruleProductFactory(rule) {
    var code = (0, _get2.default)(rule, 'code');
    var totalPrice = (0, _get2.default)(rule, 'price.total');
    var description = (0, _get2.default)(rule, 'description');
    return {
      code: code,
      description: description,
      totalPrice: totalPrice,
      displayedTotalPrice: convertAndFormat(totalPrice),
      displayedCurrency: (0, _get2.default)(rule, 'displayPrice.currency'),
      isServiceFee: (0, _includes2.default)((0, _lowerCase2.default)(description), 'service fee'),
      isDiscount: Math.sign(totalPrice) === -1
    };
  };
}